<template>
  <div class="register">
    <div class="before" v-show="!registerSuccess">
      <Form
        class="form"
        ref="formCustom"
        :model="formCustom"
        :rules="ruleCustom"
        :label-width="0"
      >
        <p>欢迎注册少儿编程账号</p>
        <div class="login-tip">
          已有账号？
          <router-link to="/login">快速登录>></router-link>
        </div>
        <FormItem prop="name">
          <Poptip placement="right">
            <i-input
              v-model="formCustom.name"
              placeholder="设置会员名"
            ></i-input>
            <div class="tip" slot="content">
              <p>• 5-25个字符，推荐使用中文</p>
              <p>• 请勿包含身份证/银行卡等隐私信息，一旦设置</p>
              <p>成功无法修改</p>
            </div>
          </Poptip>
        </FormItem>
        <FormItem prop="password">
          <Poptip placement="right">
            <i-input
              type="password"
              v-model="formCustom.password"
              placeholder="设置你的登录密码"
            ></i-input>
            <div slot="content" class="tip">
              <p>• 6-20个字符，密码不能和会员名相同</p>
              <p>• 只能包含字母、数字以及标点符号（除空格）</p>
              <p>• 字母、数字和标点符号至少包含2种</p>
            </div>
          </Poptip>
        </FormItem>
        <FormItem prop="passwordAgain">
          <Poptip placement="right">
            <i-input
              type="password"
              v-model="formCustom.passwordAgain"
              placeholder="请再次输入你的密码"
            ></i-input>
            <div slot="content" class="tip">
              <p>• 请再次输入你的密码</p>
            </div>
          </Poptip>
        </FormItem>
        <FormItem prop="phone">
          <i-input
            v-model="formCustom.phone"
            placeholder="请输入手机号"
            maxlength="11"
          >
            <span slot="prepend">+86</span>
          </i-input>
        </FormItem>
        <FormItem>
          <div class="jc-component__range">
            <div class="jc-range" :class="rangeStatus ? 'success' : ''">
              <span
                class="box"
                @mousedown="rangeMove"
                @touchstart="rangeMove"
                style="color: #fff"
              >
                <Icon :type="rangeStatus ? 'md-checkmark' : ''"></Icon>
              </span>
              <span>{{
                rangeStatus ? "验证通过" : "按住滑块滑动，拖到最右边"
              }}</span>
            </div>
          </div>
        </FormItem>
        <FormItem>
          <Button
            class="submit"
            type="primary"
            @click="handleSubmit('formCustom')"
            >同意条款并注册</Button
          >
        </FormItem>
      </Form>
      <div class="agreement">
        《少儿编程网站服务条款》 | 《法律声明和隐私权政策》
      </div>
      <Modal v-model="showPhone" title="验证手机" class="register-modal">
        <Form
          ref="formCustom2"
          :model="formCustom2"
          :rules="ruleCustom2"
          :label-width="80"
        >
          <FormItem label="手机号：">
            <span>{{ formCustom.phone }}</span>
          </FormItem>
          <FormItem label="验证码：">
            <Row type="flex">
              <i-col span="9">
                <j-graphic-code @success="generateCode" />
              </i-col>
              <i-col span="8">
                <i-input
                  maxlength="4"
                  v-model="formCustom2.graphicCode"
                  placeholder="请输入图形验证码"
                ></i-input>
              </i-col>
            </Row>
          </FormItem>
          <FormItem label="验证码：" prop="code">
            <i-input
              style="width: 200px"
              maxlength="6"
              v-model="formCustom2.code"
              @on-focus="showTip = 1"
              placeholder="请输入手机验证码"
            ></i-input>
            <Button @click="getCode" class="submit" style="margin-left: 20px">{{
              codeText
            }}</Button>
            <p v-show="showTip">
              {{
                showTip == 1
                  ? "请输入您的手机收到的验证码"
                  : "验证码已发送，请查收"
              }}
            </p>
          </FormItem>
          <FormItem>
            <Button
              class="submit"
              type="primary"
              @click="handleSubmit2('formCustom2', false)"
              >提交</Button
            >
          </FormItem>
        </Form>
      </Modal>
    </div>
    <div class="success" v-show="registerSuccess">
      <div class="success-container">
        <p class="tip">
          <Icon
            type="ios-checkmark-circle-outline"
            style="color: rgb(0, 193, 222)"
          />恭喜你，注册成功
        </p>
        <Row class="item">
          <i-col span="8">
            <span>登录名：</span>
            {{ this.formCustom.name }}
          </i-col>
          <i-col span="12">
            <span>绑定手机：</span>
            {{ this.formCustom.phone }}
          </i-col>
          <i-col span="10">
            <span>绑定微信：</span>
            <span class="bind" @click="bindWechat">去绑定</span>
          </i-col>
        </Row>
        <p class="dis">
          完成微信绑定，即可享受
          <span class="month">1个月免费使用</span> 编程游戏
        </p>
        <p class="bind-return">
          <span class="return" @click="back">返回注册前页面 ></span>
          <Button class="bind" @click="bindWechat">绑定微信</Button>
        </p>
        <div class="app">
          <p class="down">下载 APP</p>
          <img src="@/assets/custom.jpg" alt />
          <p>学习更便捷</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { register, login, getSmsCode, checkOnlyUser } from "@/api";
import { setToken, setUserInfo } from "@/utils/auth";
import JGraphicCode from "@/components/common/JGraphicCode";
export default {
  components: {
    JGraphicCode,
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入会员名"));
      } else {
        if (
          this.formCustom.name.length < 5 ||
          this.formCustom.name.length > 25
        ) {
          // 长度验证
          callback(new Error("会员名格式不正确"));
        }
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入登录密码"));
      } else {
        /**
         *  6-20个字符，密码不能和会员名相同
          • 只能包含字母、数字以及标点符号（除空格）
          • 字母、数字和标点符号至少包含2种
         */
        if (this.formCustom.name == value) {
          callback(new Error("密码不能和会员名相同"));
        }
        let level = 0;
        let reg = /^[\w]{6,20}$/;
        if (!reg.test(value)) {
          callback(new Error("密码由6-20位数字、大小写字母和特殊符号组成!"));
        }
        // 判断这个字符串中有没有数字
        if (/[0-9]/.test(value)) {
          level++;
        }
        // 判断字符串中有没有字母
        if (/[a-zA-Z]/.test(value)) {
          level++;
        }
        // 判断字符串中有没有特殊符号
        if (/[^0-9a-zA-Z_]/.test(value)) {
          level++;
        }
        if (level >= 2) {
          callback();
        } else {
          callback(new Error("字母、数字和标点符号至少包含2种"));
        }
      }
    };
    const validatePassAgain = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入登录密码"));
      } else {
        if (
          this.formCustom.passwordAgain.length < 5 ||
          this.formCustom.passwordAgain.length > 20
        ) {
          // 长度验证
          callback(new Error("登录密码格式不正确"));
        } else if (value.toString() != this.formCustom.password.toString()) {
          callback(new Error("登录密码不一致"));
        }
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("手机号格式不正确"));
        }
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        if (value.length < 4 || value.length > 6) {
          // 长度验证
          callback(new Error("验证码格式不正确"));
        }
        callback();
      }
    };
    return {
      registerSuccess: false,
      showPhone: false,
      showTip: "",
      codeText: "获取验证码",
      formCustom: {
        name: "",
        password: "",
        passwordAgain: "",
        phone: "",
        slider: 0,
      },
      ruleCustom: {
        name: [{ validator: validateName, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        passwordAgain: [{ validator: validatePassAgain, trigger: "blur" }],
        // phone: [{ validator: validatePhone, trigger: "blur" }],
      },
      formCustom2: {
        code: "",
        graphicCode: "",
        jgraphicCode: "",
      },
      codeClick: true,
      countDown: 60,
      ruleCustom2: {
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      disX: 0,
      rangeStatus: false,
      intal: null,
    };
  },
  methods: {
    //滑块移动
    rangeMove(e) {
      console.log(e);
      var touch;
      if (e.touches) {
        touch = e.touches[0];
      } else {
        touch = e;
      }
      let ele = e.target;
      let startX = touch.clientX;
      let eleWidth = ele.offsetWidth;
      let parentWidth = ele.parentElement.offsetWidth;
      let MaxX = parentWidth - eleWidth;
      if (this.rangeStatus) {
        //不运行
        return false;
      }
      document.onmousemove = (e) => {
        let endX = e.clientX;
        this.disX = endX - startX;
        if (this.disX <= 0) {
          this.disX = 0;
        }
        if (this.disX >= MaxX - eleWidth) {
          //减去滑块的宽度,体验效果更好
          this.disX = MaxX;
        }
        ele.style.transition = ".1s all";
        ele.style.transform = "translateX(" + this.disX + "px)";
        e.preventDefault();
      };
      document.ontouchmove = (e) => {
        var touch;
        if (e.touches) {
          touch = e.touches[0];
        } else {
          touch = e;
        }
        let endX = touch.clientX;
        this.disX = endX - startX;
        if (this.disX <= 0) {
          this.disX = 0;
        }
        if (this.disX >= MaxX - eleWidth) {
          //减去滑块的宽度,体验效果更好
          this.disX = MaxX;
        }
        ele.style.transition = ".1s all";
        ele.style.transform = "translateX(" + this.disX + "px)";
        //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
        // document.addEventListener("touchmove",function(){
        //     e.preventDefault();
        // },false);
      };
      document.onmouseup = () => {
        if (this.disX !== MaxX) {
          ele.style.transition = ".5s all";
          ele.style.transform = "translateX(0)";
          //执行成功的函数
          this.errorFun && this.errorFun();
        } else {
          this.rangeStatus = true;
          if (this.status) {
            this.$parent[this.status] = true;
          }
          //执行成功的函数
          this.successFun && this.successFun();
        }
        document.onmousemove = null;
        document.onmouseup = null;
      };
      document.ontouchend = () => {
        if (this.disX !== MaxX) {
          ele.style.transition = ".5s all";
          ele.style.transform = "translateX(0)";
          //执行成功的函数
          this.errorFun && this.errorFun();
        } else {
          this.rangeStatus = true;
          if (this.status) {
            this.$parent[this.status] = true;
          }
          //执行成功的函数
          this.successFun && this.successFun();
        }
        document.ontouchmove = null;
        document.ontouchend = null;
      };
    },
    //开始验证手机
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          //滑块验证
          if (!this.rangeStatus) {
            this.$Message.info("滑块验证失败");
            return;
          }
          //验证用户名
          checkOnlyUser(this.formCustom.name).then((res) => {
            if (res.success) {
              if (
                this.formCustom.phone == "" ||
                this.formCustom.phone == null
              ) {
                this.handleSubmit2("formCustom2", true);
              } else {
                this.showPhone = true;
              }
            } else {
              this.$Message.info("用户名已存在");
            }
          });
        }
      });
    },
    //提交注册信息
    handleSubmit2(name, skipValidate) {
      this.showTip = "";
      this.$refs[name].validate((valid) => {
        if (skipValidate == true || valid) {
          register(
            this.formCustom.name,
            this.formCustom.password,
            this.formCustom.phone,
            this.formCustom2.code
          ).then((res) => {
            if (res.success) {
              this.showPhone = false;
              this.$Message.success("注册成功");
              //注册完自动登录
              login(this.formCustom.name, this.formCustom.password).then(
                (res) => {
                  if (res.code === 200) {
                    setToken(res.result.token, true);
                    setUserInfo(res.result.userInfo);
                    this.registerSuccess = true;
                  } else {
                    this.$Message.info(res.message);
                  }
                }
              );
            } else {
              this.$Message.info(res.message);
            }
          });
        }
      });
    },
    //获取到图形验证码
    generateCode(value) {
      this.formCustom2.jgraphicCode = value.toLowerCase();
    },
    //获取短信验证码
    getCode() {
      // 获取验证码接口
      // 验证码发送成功时执行
      var that = this;
      if (this.formCustom2.jgraphicCode !== this.formCustom2.graphicCode) {
        this.$Message.info("图形验证码错误");
        return;
      }
      if (!this.codeClick) return;
      this.codeClick = false;
      this.countDown = 60;
      getSmsCode(this.formCustom.phone).then((res) => {
        if (res.success) {
          that.showTip = 2;
          that.codeText = "60秒后重新获取";
          that.intal = setInterval(() => {
            if (that.countDown > 0) {
              that.countDown--;
              that.codeText = that.countDown + "秒后重新获取";
            } else {
              that.codeText = "重新获取验证码";
              that.codeClick = true;
            }
          }, 1000);
        } else {
          that.codeClick = true;
          that.$Message.info(res.message);
        }
      });
    },
    back() {
      this.$router.go(-1);
    },
    bindWechat() {
      this.$router.push("/mycenter");
    },
  },
};
</script>
<style lang="scss">
.register {
  .ivu-input {
    height: 40px;
    padding-left: 15px;
    border-radius: 0;
  }
  .ivu-input-group-prepend {
    background: #fff;
    color: #999;
    border-radius: 0;
  }
  .submit {
    width: 100%;
    background: rgb(0, 193, 222);
    border: none;
    height: 40px;
    line-height: 40px;
    border-radius: 0;
    &:hover {
      background: rgb(0, 183, 211);
    }
  }
  .ivu-poptip,
  .ivu-poptip-rel {
    width: 100%;
  }
  .ivu-poptip-title {
    text-align: left;
    &.ivu-poptip-title:after {
      height: 0;
    }
  }
  .ivu-poptip-body-content-inner,
  .ivu-poptip-title-inner {
    font-size: 12px;
    color: #999;
  }

  // 表单验证提示
  .ivu-form-item-error-tip {
    top: 7px;
    width: 150px;
    left: 356px;
    text-align: left;
    color: #ff6a00;
  }
  .ivu-form-item-error .ivu-input,
  .ivu-form-item-error .ivu-input-group-prepend {
    border-color: #dcdee2;
  }
  .ivu-form-item-error .ivu-input:focus {
    box-shadow: unset;
  }
}
// 弹框底部
.register-modal {
  .ivu-modal-footer {
    display: none;
  }
  .ivu-input {
    height: 40px;
  }
  .submit {
    background: rgba(0, 193, 222, 1);
    border-radius: 0;
    border: none;
    height: 40px;
    line-height: 40px;
    color: #fff;
  }
  p {
    position: absolute;
    font-size: 12px;
    color: #36b24a;
    line-height: 26px;
    background: #fff;
    z-index: 999;
  }
  .ivu-form-item-error-tip {
    line-height: 14px;
    font-size: 12px;
    color: #ff6a00;
  }
}
</style>
<style lang="scss" scoped>
@mixin jc-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.register {
  background: rgba(106, 142, 217, 1) no-repeat 0 0;
  background-size: 100% 60px;
  margin-top: -70px;
  padding-top: 70px;
  position: relative;
  .before {
    background: #fff;
    width: 100%;
    .form {
      width: 320px;
      margin: 0 auto;
      .login-tip {
        position: absolute;
        right: 150px;
        top: 120px;
        font-size: 12px;
        color: #666;
        a {
          color: rgb(0, 193, 222) !important;
        }
      }
      > p {
        padding-top: 80px;
        margin-bottom: 30px;
        text-align: center;
        color: #333;
        font-size: 28px;
      }
      .jc-component__range {
        .jc-range {
          background-color: #e4e4e4;
          position: relative;
          transition: 1s all;
          user-select: none;
          color: #fff;
          @include jc-flex;
          height: 40px; /*no*/
          &.success {
            background-color: rgba(0, 193, 222, 1);
            color: #fff;
            i {
              color: rgba(0, 193, 222, 1);
            }
          }
          .box {
            position: absolute;
            left: 0;
            width: 50px; /*no*/
            height: 100%;
            color: rgba(0, 193, 222, 1);
            background-color: #fff;
            border: 1px solid #d8d8d8;
            cursor: pointer;
            font-size: 24px;
            @include jc-flex;
          }
        }
      }
      .tip {
        p {
          font-size: 12px;
          color: #999;
          text-align: left;
          line-height: 22px;
        }
      }
    }

    .agreement {
      font-size: 12px;
      color: rgb(0, 193, 222);
      padding-bottom: 100px;
    }
  }
  .success {
    width: 100%;
    background-color: rgb(244, 244, 244);
    padding: 20px;
    .success-container {
      width: 1200px;
      margin: 0 auto;
      background: #fff;
      border-radius: 20px;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.0470588235294118);
      padding: 0 150px;
      .tip {
        color: #666;
        font-size: 20px;
        padding-top: 80px;
        padding-bottom: 40px;
      }
      .item {
        font-size: 13px;
        color: #333;
        line-height: 80px;
        text-align: left;
        width: 700px;
        margin: 0 auto;
        span {
          color: #999;
          &.bind {
            font-weight: 400;
            color: rgb(0, 193, 222);
          }
        }
      }
      .dis {
        border-top: 1px dotted #ddd;
        padding-top: 40px;
        margin-bottom: 45px;
        color: #333;
        font-size: 12px;
        .month {
          font-weight: 400;
          color: #ff6a00;
        }
      }
      .bind-return {
        font-size: 16px;
        .return {
          margin-right: 40px;
          color: rgba(0, 193, 222, 1);
        }
        .bind {
          width: 160px;
          height: 40px;
          background-color: rgba(0, 193, 222, 1);
          color: #fff;
          border: none;
          border-radius: 0;
          font-size: 16px;
        }
      }

      .app {
        font-size: 13px;
        padding-top: 3px;
        padding-bottom: 10px;
        p {
          line-height: 50px;
          color: #999;
        }
        .down {
          color: #333;
        }
        img {
          width: 80px;
          height: 80px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/register.vue